import { connect } from "react-redux";
import { withFormik } from "formik";
import { isOwnerSelector } from "selectors/currentUser";
import {
  isAssetDetail as isAssetDetailSelector,
  isCompanyPage as isCompanyPageSelector,
} from "selectors/location";
import { selectedPortfolioSelector } from "selectors/portfolio";

import Assets from "./Assets";
import Channel from "./Channel";
import DealForm from "./DealForm";
import Description from "./Description";
import Details from "./Details";
import Portfolio from "./Portfolio";
import PortfolioAsset from "./PortfolioAsset";
import ShareStatus from "./ShareStatus";
import Tenant from "./Tenant";

export { Assets, Channel, Description, Details, Portfolio, PortfolioAsset, ShareStatus, Tenant };

export function getDefaultStage(portfolio) {
  const dealStages = Object.values((portfolio || {}).dealStages || {});

  return dealStages.length > 4 && dealStages[0] === "prospects" ? dealStages[1] : dealStages[0];
}

const mapStateToProps = (state) => ({
  assets: isAssetDetailSelector(state) ? [state.asset] : [],
  currentUser: state.currentUser,
  dealModal: state.dealModal,
  portfolio: isAssetDetailSelector(state)
    ? state.asset.portfolio
    : selectedPortfolioSelector(state),
  isAssetDetail: isAssetDetailSelector(state),
  isCompanyPage: isCompanyPageSelector(state),
  isSubmitting: state.loading.deal || state.loading.tenant || state.loading.post,
  shareStatus: isOwnerSelector(state) ? "owner_team" : "broker_owner_team",
});

const form = withFormik({
  displayName: "deal",
  enableReinitialize: true,
  mapPropsToValues: ({
    assets,
    currentUser,
    dealModal,
    isCompanyPage,
    portfolio,
    shareStatus,
  }) => ({
    assets,
    _brokers: [],
    portfolio,
    shareStatus,
    size: { unit: currentUser.company.statsUnit },
    stage: getDefaultStage(portfolio),
    _channelExpanded: dealModal.deal && dealModal.deal.channel,
    _descriptionExpanded: isCompanyPage,
    ...dealModal.deal,
  }),
  handleSubmit: (values, { props: { onSubmit }, setSubmitting }) =>
    onSubmit(values).finally(() => setSubmitting(false)),
})(DealForm);

export default connect(mapStateToProps)(form);
